{
  "completed": "Terminé : ",
  "current": "Actuel : ",
  "notCompleted": "Pas terminé : ",
  "steplist": "Liste des étapes"
}
